<template>
  <div class="staggered-images" v-if="images.length">
    <div class="staggered-images__header">
      <b><font face="微软夜黑" style="font-size: 18pt" color="#FFFFFF">{{ title }}</font></b>
    </div>
    <div class="staggered-images__grid">
      <div class="staggered-images__col">
        <div v-for="(img, i) in colLeft" :key="'l' + i" class="staggered-images__item">
          <img :src="imgSrc(img)" class="staggered-images__img" alt="" @click="openPreview(imgSrc(img))" />
          <div v-if="imgDesc(img)" class="staggered-images__desc">{{ imgDesc(img) }}</div>
        </div>
      </div>
      <div class="staggered-images__col">
        <div v-for="(img, i) in colRight" :key="'r' + i" class="staggered-images__item">
          <img :src="imgSrc(img)" class="staggered-images__img" alt="" @click="openPreview(imgSrc(img))" />
          <div v-if="imgDesc(img)" class="staggered-images__desc">{{ imgDesc(img) }}</div>
        </div>
      </div>
    </div>

    <div v-if="previewSrc" class="staggered-images__preview" role="dialog" aria-modal="true" aria-label="图片预览" @click.self="closePreview">
      <button type="button" class="staggered-images__preview-close" aria-label="关闭预览" @click="closePreview">&times;</button>
      <img class="staggered-images__preview-img" :src="previewSrc" alt="预览" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StaggeredImages',
  props: {
    images: { type: Array, default: () => [] },
    title: { type: String, default: '网络热图' }
  },
  data() {
    return {
      previewSrc: null
    }
  },
  computed: {
    colLeft() {
      return this.images.filter((_, i) => i % 2 === 0)
    },
    colRight() {
      return this.images.filter((_, i) => i % 2 === 1)
    }
  },
  watch: {
    previewSrc(val) {
      document.body.style.overflow = val ? 'hidden' : ''
    }
  },
  mounted() {
    this._onKeydown = e => { if (e.key === 'Escape' && this.previewSrc) this.closePreview() }
    document.addEventListener('keydown', this._onKeydown)
  },
  beforeDestroy() {
    document.body.style.overflow = ''
    document.removeEventListener('keydown', this._onKeydown)
  },
  methods: {
    imgSrc(img) {
      return typeof img === 'string' ? img : (img.src || '')
    },
    imgDesc(img) {
      return typeof img === 'string' ? '' : (img.desc || '')
    },
    openPreview(src) {
      this.previewSrc = src
    },
    closePreview() {
      this.previewSrc = null
    }
  }
}
</script>

<style scoped>
.staggered-images {
  margin: 0.5rem 0;
  background: #fff;
  border: 1px solid #000000;
  box-shadow: 0 2px 8px rgba(30, 107, 214, 0.08);
  overflow: hidden;
}
.staggered-images__header {
  border: 8px double #ff9900;
  background: #009900;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.staggered-images__grid {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.5rem;
}
.staggered-images__col {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.staggered-images__item {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
}
.staggered-images__img {
  display: block;
  width: 100%;
  height: auto;
  cursor: zoom-in;
}
.staggered-images__desc {
  padding: 0.3rem 0.25rem;
  font-size: 1rem;
  font-weight: 600;
  color: #1a365d;
  text-align: center;
  line-height: 1.35;
  word-break: break-word;
}
.staggered-images__preview {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(0.75rem, 4vw, 1.25rem);
  padding-top: max(clamp(0.75rem, 4vw, 1.25rem), env(safe-area-inset-top));
  padding-bottom: max(clamp(0.75rem, 4vw, 1.25rem), env(safe-area-inset-bottom));
  background: rgba(0, 0, 0, 0.88);
  box-sizing: border-box;
}
.staggered-images__preview-close {
  position: absolute;
  top: max(0.5rem, env(safe-area-inset-top));
  right: max(0.5rem, env(safe-area-inset-right));
  width: 2.5rem;
  height: 2.5rem;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 1.75rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.staggered-images__preview-img {
  max-width: 100%;
  width: auto;
  height: auto;
  max-height: min(85vh, calc(100vh - 5rem));
  object-fit: contain;
  border-radius: clamp(0.25rem, 1.5vw, 0.5rem);
}
</style>
